// extracted by mini-css-extract-plugin
module.exports = {"cartDrawer":"drawer-module--cartDrawer--3cVPo","noticeBarVisible":"drawer-module--noticeBarVisible--2vfzI","cartViewContainer":"drawer-module--cartViewContainer--1GEej"};